import React, { useEffect, useState } from 'react'
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import VerticalTable from '../../components/verticalTable';
import LineChart from '../../components/chartTypes/lineChart';
import { Column } from 'react-table';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';
import { productFlowByEwi } from '../../services/flowRates';

const ProductOfFlowsKeralaEWI = () => {
    const { t } = useTranslation();

     
    
 
     const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
             periodWithOutDay: ["month"],
             state: ["18"], 
             fromDate: [sixMonthsAgoFormatted],
             toDate: [twoDaysAgoFormatted]
             }));
         
     const filters =  [
        { key: "state", type: "select", label: t("filters.state") },
        // { key: "territory", type: "select", label: t("filters.territory") },
        { key: "cluster", type: "select", label: t("filters.cluster") },
        { key: "branch", type: "select", label: t("filters.branch") },
        { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period") },
        { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate  },
        { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
    ];
 
     const [applyFilter, setApplyFilter] = useState<boolean>(false);
     // const [portfolioSummary, setPortfolioSummary] = useState<any[]>([]);
     const [portfolioSummary, setPortfolioSummary] = useState<{ headers: string[]; data: { category: string; values: string[] }[] }>({
         headers: [],
         data: [],
     });
     const [principalDPDEwi, setPrincipalDPDEwi] = useState<{ headers: string[]; data: { category: string; values: string[] }[] }>({
         headers: [],
         data: [],
     });
     const [portfolioMovement, setPortfolioMovement] = useState<any[]>([]);
     const [loading, setLoading] = useState<boolean>(true);
     const [principalDPDEwiLoading, setPrincipalDPDEwiLoading] = useState<boolean>(true);
     const [error, setError] = useState<string | null>(null);
     const [sampleData, setSampleData] = useState<{ category: string; values: string[] }[]>([]);
    const [period, setPeriod] = useState<any[]>([]);

const generateproductKeralaEwi= async () => {
        setLoading(true)
            try {
            const response = await productFlowByEwi(selectedFilters); // Call the API function
            let period = ["", ...response.data.map((obj: any) => obj.period)]
            let flowBucket = response.data.map((obj: any) => obj.flow_bucket)

            const apiData = response.data; // from your API

            // Use a Map to accumulate flow values by flow category
            const flowMap = new Map<string, string[]>();

            apiData.forEach((periodEntry : any) => {
            periodEntry.product_flow_bucket.forEach((bucket: any) => {
                // Normalize the flow name to match your sample format (e.g., "01. C -> X")
                const flowLabel = bucket.product_flow.trim().toLowerCase().replace(/\b\w/g, (c: any) => c.toUpperCase());

                if (!flowMap.has(flowLabel)) {
                flowMap.set(flowLabel, []);
                }

                flowMap.get(flowLabel)?.push(bucket.flow_value_product.toString());
            });
            });

            // Convert Map to desired array format
            const sampleData = Array.from(flowMap.entries()).map(([category, values]) => ({
                category,
                values
            }));

            setSampleData(sampleData)
            setPeriod(period)


            } catch (err) {
            setError("Failed to fetch users");
            console.error(err);
            } finally {
            setLoading(false);
            }
        };
     
    const getColorForCategory = (category: string): string => {
        const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
        return randomColor;
      };


     const handleFilterChange = (updatedValues: Record<string, string[]>) => {
         setSelectedFilters(updatedValues);
         };
 
     const handleCancelClick = () => {
         setSelectedFilters({
             periodWithOutDay: ["month"],
             state: ["18"], //kerala
             fromDate: [sixMonthsAgoFormatted],
             toDate: [twoDaysAgoFormatted]
         })
         setApplyFilter(!applyFilter)
         }

         useEffect(() => {
            generateproductKeralaEwi();
              }, [applyFilter]);
 
    
 
    


   return (
     <div>
         {/* Page Content */}
         <div className="page-content">
             {/* Dynamic Grey Header */}
             <div className="header">
             {t('productOfFlows.productKeralaEWI.pageTitle')}
             </div>
 
             <div className="content px-3">
                 <MultiSelectCheckboxGroup 
                 filters={filters} 
                 selectedValues={selectedFilters} 
                 onChange={handleFilterChange} 
                 isLoading={[loading]}
                 buttons={[
                    { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter)},
                    { label: t("buttons.cancel"), onClick: () => handleCancelClick()},
                    { label: t("buttons.download"), onClick: () => alert("download btn clicked")},
                ]}
                 />
             </div>
           
             <div className="p-2 me-3">
                 <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('productOfFlows.productKeralaEWI.Product Of Flows Kerala- EWI')}</h2>
                 <VerticalTable headers={period} data={sampleData} loading={loading}/>
 
             </div>
             <div className="mt-1 p-2">
                 <LineChart 
                     title={t('productOfFlows.productKeralaEWI.title')}
                     labels={period.slice(1)}
                     dataSets={sampleData.map(item => ({
                        label: item.category,
                        data: item.values.map(value => parseFloat(value)), // convert string to number
                        borderColor: getColorForCategory(item.category), // custom function to assign colors
                      }))}
                     xLabel={t('productOfFlows.productKeralaEWI.xLabel')}
                     yLabel={t('productOfFlows.productKeralaEWI.yLabel')}
                 />
             </div>
         </div>
     </div>
   )
 }

export default ProductOfFlowsKeralaEWI;
